import React from 'react';

export default ({ children })=> (
	<div className='SpecialInstructions'>
		<div className='SpecialInstructions_label'>Special Instructions:</div>
		<div className='SpecialInstructions_body'>{ children }</div>
	</div>
);
